import { AuthorizationRequestData } from "apex-ui-services";
import { uniq } from "lodash";

export enum PermissionsEnum {
  AccountRead = "occbalancing.read",
}

export const ALL_REQUESTED_PERMISSIONS: string[] = uniq([
  PermissionsEnum.AccountRead,
]);

export const convertToAuthRequest = (permissions: string[]) => {
  return permissions.map((permission) => {
    return {
      permission,
    } as AuthorizationRequestData;
  });
};
